// import { Contract } from "@ethersproject/contracts";

import axios from "axios";
import CryptoJS from "crypto-js";
import moment from "moment";
import { store } from "../Redux/store";
import Apiconfigs from "../ApiConfig/Apiconfig";

const base64Key = "w2IKah2csuNE77fv1Zd8+jzxcJ2GYh3WO5UZMqfHj3Y=";

export const WebsiteLinks =
  "http://sarus-elb-345957920.ap-south-1.elb.amazonaws.com:8080/";
export function sortAddress(add) {
  const sortAdd = `${add.slice(0, 80)}...`;
  return sortAdd;
}
export const map = {
  // googleMapKey: "AIzaSyBpWyPnAG_3CFQC3NU0hJPt4r_IBhpsPEA",
  googleMapKey: "",
};

export function getSigner(library, account) {
  return library.getSigner(account).connectUnchecked();
}

export function getProviderOrSigner(library, account) {
  return account ? getSigner(library, account) : library;
}

export async function decryptData(encryptedBase64) {
  const encryptedBytes = Uint8Array.from(atob(encryptedBase64), (c) =>
    c.charCodeAt(0)
  );

  const iv = encryptedBytes.slice(0, 12);

  const ciphertext = encryptedBytes.slice(12);

  const secret = base64Key;

  const secretBytes = Uint8Array.from(atob(secret), (c) => c.charCodeAt(0));

  const keyHash = await crypto.subtle.digest("SHA-256", secretBytes);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",

    keyHash,

    { name: "AES-GCM" },

    false,

    ["decrypt"]
  );

  const decrypted = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",

      iv: iv,
    },

    cryptoKey,

    ciphertext
  );

  const decoder = new TextDecoder();

  return JSON.parse(decoder.decode(decrypted));
}

const csrf_token_Generate = async (token) => {
  try {
    const res = await getAPIdata({
      endPoint: Apiconfigs.csrf_token,
    });
    if (res) {
      return res?.csrfToken;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getAPIdata = async ({ endPoint }) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(endPoint, {
      headers: {
        Authorization: token ? `${token}` : undefined,
      },
    });

    if (response.status === 200) {
      return decryptData(response.data);
    } else {
      return response.data;
    }
  } catch (error) {
    console.error("API Fetch Error:", error?.message);
    return error?.response?.data;
  }
};

export const putAPIdata = async ({ params, data, endPoint, headers }) => {
  try {
    let res;

    res = await axios({
      url: endPoint,
      method: "PUT",
      params: params,
      data: data,
      headers: headers,
    })
      .then((res) => {
        if (res?.data?.status === 200) {
          return res?.data?.data;
        }
        if (res?.data?.status === 400) {
          return false;
        }
        if (res?.data?.status === 401) {
          return false;
        }
      })
      .catch((error) => {
        return false;
      });
    return res;
  } catch (error) {
    return false;
  }
};

export const PostApiFunction = async ({
  endPoint,
  data,
  headers = {},
  withCredentials = false,
}) => {
  try {
    const csrfToken = await csrf_token_Generate();
    const res = await axios({
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `${
          localStorage?.getItem("token") !== null &&
          localStorage?.getItem("token")
        }`,
        ...headers,
      },
      withCredentials: true,
      mode: "same-origin",
    });

    if (res?.status === 200) {
      return decryptData(res?.data);
    } else {
      return false;
    }
  } catch (error) {
    return error;
  }
};

export const convertDateTime = (val) => {
  var tempDate = new Date(val);
  const toDateFormat = moment(tempDate).format("DD-MMM-yyyy hh:mm a");

  return toDateFormat;
};

export const localeFunction = (key) => {
  let str = store.getState("auth");
  let langCode = str.auth.langCode;
  switch (langCode) {
    case "en":
      return require(`../utils/lang/en`)[key];
    default:
      return require(`../utils/lang/${langCode}`)[key];
  }
};
